import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const messageUs: IMcAppType = {
  name: "messageUs",
  path: "/my/message-us",
  description: "Message Us",
  navFlow: NavFlow.STANDARD,
  title: "Message Us",
  parent: Tab.MORE,

  conditions: {
    intent: "messageUs",
    customerType: CustomerType.kraken,
  },
};
